import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminPortal from "@/components/AdminPortal";
import LandingPage from "@/components/LandingPage";
import LegalPage from "@/components/LegalPage";
import { legalPages } from "@/data/legalPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="/privacy" element={<LegalPage key="privacy" document={legalPages.privacy} />} />
          <Route path="/terms" element={<LegalPage key="terms" document={legalPages.terms} />} />
          <Route path="/disclaimer" element={<LegalPage key="disclaimer" document={legalPages.disclaimer} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
